/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/extensions */
// eslint-disable-next-line no-use-before-define
import React, {
  FC, useContext, useState, useEffect,
} from 'react';
import clsx from 'clsx';
import {
  Route,
  Switch,
  Redirect,
  RouteComponentProps,
  useHistory,
} from 'react-router-dom';
import {
  Paper, Box, Typography, List, Container, CircularProgress,
} from '@mui/material';
import Login from './pages/Login/login';
import Dashboard from './pages/Dashboard';
import Cadastro from './pages/Cadastro';
import NovaSolicitacao from './pages/NovaSolicitacao';
import MinhaSolicitacao from './pages/MinhaSolicitacao';
import EmailPage from './pages/Email';
import Historico from './pages/Historico';
import Header from './components/Header';
import { LoginStore, LinksStore } from './services/zustandProvider';
import { getUser, getLinks } from './services/loginAPI';
import { colors } from './services/colors';

interface IProps {
  path: string;
  exact: boolean;
  Component: FC<RouteComponentProps>;
  // any other props that come into the component
}

function Splash(on: any) {
  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: on?.on,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: colors.themePrimary,
      zIndex: 99999999,
      margin: '0px !important',
    }}
    >
      <CircularProgress sx={{ color: 'white' }} />
    </Box>
  );
};

const PrivateRoute = ({ Component, ...rest }:IProps) => {
  const { Log } = LoginStore();
  return (
    <Route
      {...rest}
      render={(props) => (Log === true ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login' }} />
      ))}
    />
  );
};

export default function App():JSX.Element {
  const [modalShow, setModalshow] = useState(false);
  const [splashOn, setSplashOn] = useState<string>('flex');
  const [ip, setIp] = useState('');
  const [change, setChange] = useState(0);
  const history = useHistory();
  const [auth, setAuth] = useState(false);
  const {
    setUserAtivo, userAtivo, Log, setLog,
  } = LoginStore();
  const {
    setLinkSite,
    setLinkPoliticas,
    setImagem,
  } = LinksStore();

  useEffect(() => {
    async function get() {
      console.log('get');
      const getlinksRetorno = await getLinks();
      console.log(getlinksRetorno);
      if (getlinksRetorno.sucesso) {
        if (getlinksRetorno.dados) {
          setLinkSite(getlinksRetorno?.dados?.linkWebSite);
          setLinkPoliticas(getlinksRetorno?.dados?.linkPoliticas);
          setImagem(getlinksRetorno?.dados?.base64Logo);
        }
      }
      const userget = await getUser().catch((e) => {
        setSplashOn('none');
      });
      if (userget?.sucesso) {
        setLog(true);
        setAuth(true);
        setUserAtivo(userget?.dados);
        if ((userget?.dados?.confirmarEmail !== 'Sim') || (userget?.dados?.confirmarDPO !== 'Sim')) {
          history.push('/Cadastro');
        } else {
          history.push('/Dash');
        }
        setSplashOn('none');
      } else {
        console.log('consexão');
      }
    }
    if (!Log) {
      get();
    }
  }, []);

  return (
    <>
      <Splash on={splashOn} />
      <Header />
      <Box sx={{
        marginTop: Log ? '120px' : 0,
      }}
      >
        <Switch>
          <Route exact path="/Login" component={Login} />
          <Route exact path="/seccionPage" component={EmailPage} />
          <Route exact path="/EmailPage" component={EmailPage} />
          <PrivateRoute exact path="/" Component={Dashboard} />
          <PrivateRoute exact path="/Dash" Component={Dashboard} />
          <Container>
            <Route exact path="/Cadastro" component={Cadastro} />
            <PrivateRoute exact path="/NovaSolicitacao" Component={NovaSolicitacao} />
            <PrivateRoute exact path="/MinhaSolicitacao/:id" Component={MinhaSolicitacao} />
            <PrivateRoute exact path="/Historico" Component={Historico} />
          </Container>
        </Switch>
      </Box>
    </>
  );
}
